



























































































































































































































































































import InvoicePartySheet from "@/components/invoice/InvoicePartySheet.vue";
import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import SelectAssignees from "@/components/utility/SelectAssignees.vue";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { TotalLossType } from "@/lib/enum/total-loss-type.enum";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Appraisal, IAppraisal } from "@/models/appraisal.entity";
import { IReport } from "@/models/report.entity";
import { ISharedContent } from "@/models/shared-content.entity";
import CompanyMapDialog from "@/views/company/CompanyMapDialog.vue";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import PartnerReportAppraisalUpdateDialog from "../partner/report/v2/repair/PartnerReportAppraisalUpdateDialog.vue";
import ReportAppraisalEstimateSendDialog from "../partner/report/v2/repair/ReportAppraisalEstimateSendDialog.vue";
import SharedContentSideCard from "../partner/SharedContentSideCard.vue";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import { handleError } from "@/lib/utility/handleError";

@Component({
  components: {
    MIconButton,
    MNoContent,
    CompanyMapDialog,
    MTextField,
    MSelect,
    InvoicePartySheet,
    LineItemsForm,
    SelectAssignees,
    PartnerReportAppraisalUpdateDialog,
    ReportAppraisalEstimateSendDialog,
    SharedContentSideCard,
    ConfirmActionDialog
  },
  filters: {}
})
export default class AppraisalSheet extends mixins(PermissionMixin) {
  private readonly RequestStatusEnum = RequestStatusEnum;

  @Prop({ required: true }) readonly appraisal!: IAppraisal;
  @Prop() readonly report?: IReport;
  @Prop({ type: Boolean, default: false }) readonly hideGoToDetail!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideSharingLink!: boolean;

  showDocument = false;
  showPositions = false;
  isUpdateDialog = false;
  isSendDialog = false;
  isDeleteDialogActive = false;
  isDeleteLoading = false;

  sharedContentSideCardItem?: ISharedContent | null = null;
  localAppraisal: IAppraisal = new Appraisal({});

  get filters() {
    const filter: IPageFilterElement[] = [];
    if (!this.report) return filter;

    filter.push(new PageFilterElement({ value: this.report.id, key: "refs.refId", operation: "$eq" }));

    return filter;
  }

  openUpdateDialog() {
    if (this.canUpdateAppraisal) {
      this.isUpdateDialog = true;
    }
  }

  created() {
    this.localAppraisal = this.appraisal;
  }

  @Watch("appraisal", { immediate: true, deep: true })
  onAppraisalChanged(val: IAppraisal) {
    this.localAppraisal = val;
  }

  emitUpdateAppraisal() {
    this.$emit("update:appraisal", this.localAppraisal);
  }

  async onAssigneesUpdate(assignees: []) {
    await this.localAppraisal.updatePartial({ assignees });
  }

  async onAssigneesAdded(assignees: string[]) {
    if (!this.canUpdateAppraisal) return;
    await this.localAppraisal.createAssigneeActivity(ActivityTypeEnum.CREATE_ASSIGNEE, assignees);
  }

  async onAssigneesRemoved(assignees: string[]) {
    if (!this.canUpdateAppraisal) return;
    await this.localAppraisal.createAssigneeActivity(ActivityTypeEnum.DELETE_ASSIGNEE, assignees);
  }

  goToDetail() {
    if (!this.canUpdateAppraisal) return;
    this.localAppraisal.goTo(this.$router).detail();
  }

  get statusItems() {
    return Object.values(RequestStatusEnum).map(value => ({
      value,
      text: this.$t(`enums.RequestStatusEnum.${value}`)
    }));
  }

  get TotalLossTypeItems() {
    return Object.values(TotalLossType).map(value => ({
      value,
      text: this.$t(`enums.TotalLossType.${value}`)
    }));
  }

  emitDelete() {
    this.$emit("delete", this.localAppraisal);
  }

  async onDelete() {
    this.isDeleteLoading = true;
    try {
      await this.localAppraisal?.delete().then(() => {
        this.isDeleteLoading = false;
        this.isDeleteDialogActive = false;
        this.$toast.success("👍");
      });
      this.emitDelete();
    } catch (error) {
      handleError(error);
    } finally {
      this.isDeleteLoading = false;
      this.isDeleteDialogActive = false;
    }
  }

  openDeleteDialog() {
    if (this.canDeleteRepairEstimate) {
      this.isDeleteDialogActive = true;
    }
  }
}
